import { Container, Modal, Icon, Transition, Header, Button } from 'semantic-ui-react'
import SupportedBrowserGrid from './SupportedBrowserGrid'
import { Text } from 'preact-i18n'
import { useStore } from '../../../store'
const PartiallySupportedBrowserModal = () => {
  const store = useStore()
  const open = store.errorsStore.hasPartialSupport.value && !store.singleImageModeStore.enabled.value
  return (
    <Transition visible={open} animation="scale" duration={350} unmountOnHide>
      <Modal id="partially-supported-modal" basic open={true} size="tiny">
        <Modal.Content>
          <Header icon inverted textAlign="center">
            <Icon name="warning sign" />
            <Text id="warnings.browser.partialSupport.title" />
          </Header>
          <p>
            <Text id="warnings.browser.partialSupport.message1" />
          </p>
          <p>
            <Text id="warnings.browser.partialSupport.message2" />
          </p>
          <p>
            <Text id="warnings.browser.partialSupport.message3" />
          </p>
          <SupportedBrowserGrid />
        </Modal.Content>
        <Modal.Actions>
          <Container textAlign="center">
            <Button color="green" inverted onClick={store.singleImageModeStore.enable}>
              <Icon name="checkmark" />
              <Text id="actions.continue" />
            </Button>
          </Container>
        </Modal.Actions>
      </Modal>
    </Transition>
  )
}
export default PartiallySupportedBrowserModal
